<template>
  <el-card class="box-card" style="margin: 30px;">
    <el-container>
      <el-header>
        <div style="margin-top: 20px;flex-flow: row; flex-wrap: wrap; justify-content: flex-start;"  class="pcenter">
          <div style="margin-top: 5px; margin-right: 10px;"><el-input v-model="query_goods_name" placeholder="请输入产品名称"></el-input>
          </div>
          <div style="margin-top: 5px; margin-right: 10px;"><el-select v-model="query_goods_type" filterable clearable placeholder="请选择产品类别" height="120px">
            <el-option
              v-for="item in goodstypelist"
              :key="item.id.Int64"
              :label="item.name.String"
              :value="item.id.Int64">
            </el-option>
          </el-select></div>
          <div style="margin-top: 5px; margin-right: 10px;">
            <el-button type="primary" icon="el-icon-search" @click="querygoods">查找产品</el-button>
          </div>
        </div>
      </el-header>
      <el-main class="pcenter" style="margin-top:40px; flex-flow: column;border: 1px solid #f0f3f7;">
        <div style="display: flex; flex-flow: column; margin-top: 20px; margin-bottom: 40px; align-items: center; justify-content: center;">
          <div style="margin-bottom: 10px;">
            <el-pagination
              ref="elpage"
              @size-change="sizechange"
              @current-change="curpagehange"
              :current-page="currentPage"
              :page-sizes="[size]"
              :page-size=size
              layout="total, sizes, prev, pager, next, jumper"
              :total=total>
            </el-pagination>
          </div>
          <div style="display: flex; flex-flow: row; flex-wrap: wrap;">
            <div style="width: 160px; margin-top: 30px; display: flex; flex-flow: column; justify-content: center; align-items: center; margin-left:10px;margin-right:10px;" v-for="(goods,index) in cusgoodsdata" :key="index" @click="showgoods(goods.id,goods.goodstypeid)">
              <el-image
                style="width: 100px; height: 100px"
                :src="goods.img_url"
                fit="cover">
              </el-image>
              <span style="margin-top: 10px;">{{ goods.name }}</span>
            </div>
          </div>
        </div>
        <el-dialog title="产品显示" :visible.sync="gsvisible" :before-close="closedia">
          <GShow @showbaseinfo="showbaseinfo" @colsepage="colsepage" @qgoods="querygoods" @showattrinfo="showattrinfo" @showimg="showimg" @showspecinfo="showspecinfo" ref="gshow"></GShow>
        </el-dialog>
      </el-main>
    </el-container>
  </el-card>
</template>

<script>
  import EGoodsBase from './EGoodsBase'
  import Vue from 'vue'
  import axios from 'axios'
  import GShow from './GShow'
  import EMAttrs from './EMAttrs'
  import EMSpec from './EMSpec'
  import EGImg from './EGImg'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'GStore',
    components: {
      GShow,
      EGoodsBase,
      EMAttrs,
      EGImg,
      EMSpec
    },
    data () {
      return {
        cusgoodsdata: [],
        goodstypelist: [],
        dtitle: '商品基础属性',
        drawer: false,
        query_goods_name: '',
        query_goods_type: '',
        gsvisible: false,
        egvisible: true,
        aboday: false,
        mavisible: true,
        egivisible: false,
        msvisible: false,
        wheader: true,
        curgoodsid: '',
        total: 0,
        curpage: 1,
        size: 30,
        currentPage: 1,
        curindex: 0
      }
    },
    mounted () {
      that = this
      if (getCookie('cusid') !== 0 || getCookie('cusid') !== '' || getCookie('cusid') !== undefined) {
        this.khid = getCookie('cusid')
      } else {
        this.khid = 1
      }
      if (that.khid === null) {
        that.$message({
          type: 'info',
          message: 'Cookie已失效，请重新登录!'
        })
        that.$router.push({path: '/'})
      } else {
        that.querygoodstype()
        that.querygoodscount()
        that.querygoods()
      }
    },
    methods: {
      colsepage () {
        this.gsvisible = false
      },
      sizechange (val) {
        console.log('每页' + val + '条')
      },
      curpagehange (val) {
        that.querygoodsbypage(parseInt(val) - 1)
      },
      closedia () {
        document.body.style.overflow= 'scroll'
        this.gsvisible = false
      },
      querygoodstype () {
        var qstr1 = 'cusid = ' + that.khid + ' and parentid >0'
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/goods/qgt',
          method: 'post',
          data: {
            whereinfo: {String: qstr1, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log('*****************初始化分类数据******************')
            if (res.data.success) {
              console.log('已完成分类数据初始化')
              that.goodstypelist = JSON.parse(res.data.data)
            } else {
              console.log('获取分类数据失败')
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      querygoodscount () {
        var qstr = " ownphone='" + localStorage.getItem('username') + "'"
        if (that.query_goods_name !== null && that.query_goods_name !== '') {
          qstr = qstr + " and name like '%" + that.query_goods_name + "%' "
        }
        if (that.query_goods_type !== null && that.query_goods_type !== '') {
          qstr = qstr + ' and find_in_set(' + that.query_goods_type + ',goods_type_id)'
        }
        var qstrinfo = {
          whereinfo: qstr,
          limit: ' ',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/queryginfo',
          method: 'post',
          data: qstrinfo,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.total = res.data.length
            } else {
              that.total = 0
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      querygoodsbypage (val) {
        var qstr = " ownphone='" + localStorage.getItem('username') + "'"
        if (that.query_goods_name !== null && that.query_goods_name !== '') {
          qstr = qstr + " and name like '%" + that.query_goods_name + "%' "
        }
        if (that.query_goods_type !== null && that.query_goods_type !== '') {
          qstr = qstr + ' and find_in_set(' + that.query_goods_type + ',goods_type_id)'
        }
        var qstrinfo = {
          whereinfo: qstr,
          limit: ' limit ' + val*that.size + ',' + that.size,
          sortinfo: ' order by id desc'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/queryginfo',
          method: 'post',
          data: qstrinfo,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.cusgoodsdata = res.data
            } else {
              that.cusgoodsdata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      querygoods () {
        var qstr = " ownphone='" + localStorage.getItem('username') + "'"
        if (that.query_goods_name !== null && that.query_goods_name !== '') {
          qstr = qstr + " and name like '%" + that.query_goods_name + "%' "
        }
        if (that.query_goods_type !== null && that.query_goods_type !== '') {
          qstr = qstr + ' and find_in_set(' + that.query_goods_type + ',goods_type_id)'
        }
        var qstrinfo = {
          whereinfo: qstr,
          limit: ' limit 0,' + that.size,
          sortinfo: ' order by id desc'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/queryginfo',
          method: 'post',
          data: qstrinfo,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.cusgoodsdata = res.data
            } else {
              that.cusgoodsdata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      showbaseinfo () {
        this.drawer = true
        this.egvisible = false
        this.mavisible = true
        this.egivisible = true
        this.msvisible = true
        setTimeout(() => {
          this.$refs.gb.showbaseinfo(that.curgoodsid) // 方法1:触发监听事件
        },0)
      },
      showattrinfo () {
        this.drawer = true
        this.egvisible = true
        this.mavisible = false
        this.egivisible = true
        this.msvisible = true
        setTimeout(() => {
          this.$refs.em.initattrs(that.curgoodsid)
        },0)
      },
      showgoods(val,gtypeid) {
        this.gsvisible = true
        that.curgoodsid = val
        window.console.log(val)
        localStorage.setItem('showgoodstype', gtypeid)
        localStorage.setItem('editgoodsid', val)
        setTimeout(() => {
          this.$refs.gshow.reloaddata()
        },0)
      },
      showimg () {
        this.drawer = true
        this.egivisible = false
        this.egvisible = true
        this.mavisible = true
        this.msvisible = true
        setTimeout(() => {
          this.$refs.egi.showimg(that.curgoodsid) // 方法1:触发监听事件
        },0)
      },
      showspecinfo () {
        this.drawer = true
        this.egivisible = true
        this.egvisible = true
        this.mavisible = true
        this.msvisible = false
        setTimeout(() => {
          this.$refs.ems.showspec(that.curgoodsid) // 方法1:触发监听事件
        },0)
      },
      closedrawer () {
        this.gsvisible = true
        this.drawer = false
        window.console.log('关闭')
        setTimeout(() => {
          this.$refs.egi.getimgs()
        },0)
      }
    }
  }
  function getCookie (name) {
    var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    return v ? v[2] : null
  }
</script>

<style scoped>
  .el-drawer__header {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    color: #72767b;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    /* margin-bottom: 32px; */
    padding: 20px 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/newgoods/GStore.vue